import growth_img from '~/assets/img/retail-media/campaign-strategy/growth.png'
import profitability_img from '~/assets/img/retail-media/campaign-strategy/profitability.png'
import reach_img from '~/assets/img/retail-media/campaign-strategy/reach.png'

export const goalImageMap: Record<Goals, string> = {
  growth: growth_img,
  profitability: profitability_img,
  reach: reach_img
}
